import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgComponent = ({ title, titleId, ...props }) => /* @__PURE__ */ _jsxs("svg", {
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M8.37996 15.0933C12.0876 15.0933 15.0933 12.0876 15.0933 8.37996C15.0933 4.67229 12.0876 1.66663 8.37996 1.66663C4.67229 1.66663 1.66663 4.67229 1.66663 8.37996C1.66663 12.0876 4.67229 15.0933 8.37996 15.0933Z",
			stroke: "black",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M13.1266 13.1265L18.3333 18.3339",
			stroke: "#262626",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		})
	]
});
export const ReactComponent = SvgComponent;
export default "data:image/svg+xml,%3Csvg%20width%3D%2220%22%20height%3D%2220%22%20viewBox%3D%220%200%2020%2020%22%20fill%3D%22none%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E%3Cpath%20fill-rule%3D%22evenodd%22%20clip-rule%3D%22evenodd%22%20d%3D%22M8.37996%2015.0933C12.0876%2015.0933%2015.0933%2012.0876%2015.0933%208.37996C15.0933%204.67229%2012.0876%201.66663%208.37996%201.66663C4.67229%201.66663%201.66663%204.67229%201.66663%208.37996C1.66663%2012.0876%204.67229%2015.0933%208.37996%2015.0933Z%22%20stroke%3D%22black%22%20stroke-width%3D%221.5%22%20stroke-linecap%3D%22round%22%20stroke-linejoin%3D%22round%22%2F%3E%3Cpath%20d%3D%22M13.1266%2013.1265L18.3333%2018.3339%22%20stroke%3D%22%23262626%22%20stroke-width%3D%221.5%22%20stroke-linecap%3D%22round%22%20stroke-linejoin%3D%22round%22%2F%3E%3C%2Fsvg%3E%0A";
